// extracted by mini-css-extract-plugin
export default {"wrapper":"block-wrapper_wrapper__uu6ue","title":"block-wrapper_title__LBudU"};